import type { FaireProductEntity } from "../../entity_types/product";

export const p_9w2jlrggen: FaireProductEntity = {
  token: "p_9w2jlrggen",
  type: "product",
  name: "Original Extra Virgin Olive Oil (375ml)",
  brandToken: "b_8v4yrvb98p",
  brandName: "Kosterina",
  imageUrl:
    "https://cdn.faire.com/fastly/9a963c5d6b4918f440f6ed66467c88f727bd7d7bc67def809c180e452a43a42c.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dab8822d4c6e1cd6e9a688126a0d04c179abc7e01bb4ff36b9c11d22108c5565.jpeg",
    "https://cdn.faire.com/fastly/a2fa70dbe9347711906933aaf109c0be8cb971938e2064d7da754ff49abfc5ae.jpeg",
    "https://cdn.faire.com/fastly/57ef80a41cf5388ca1ec545269030a274aca696922ffb86777c3b2b05c1afc21.jpeg",
  ],
  priceDollars: 24.94,
  description:
    "Award Winning Olive Oil: Named the 2025 World's Best Olive Oil by NYIOOC World Olive Oil Competition\n\nElevate your everyday with our Original Extra Virgin Olive Oil. Cold pressed in small batches from a single blend of early harvest Koroneiki olives grown in the Peloponnese region of southern Greece, our EVOO has a high chlorophyll content, making it rich in healthy polyphenols (an anti-inflammatory antioxidant). Polyphenol content measuring over 55mg/kg is required for an olive oil to be deemed extra virgin - this Kosterina harvest measured 430 mg/kg of polyphenol content!.",
  tags: [],
  msrpDollars: 33.19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:11.055Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
